import { render, staticRenderFns } from "./PendingAndUserModifiedGroup.vue?vue&type=template&id=7ea62b50"
import script from "./pendingAndUserModifiedGroup.ts?vue&type=script&lang=ts&external"
export * from "./pendingAndUserModifiedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports